import { useSyncExternalStore } from "react";

import { useIsMobileViewport } from "@wags/tanstack-start/react";
import {
    type ChatFabMode,
    requestChatFabDock,
    requestChatFabMode,
} from "./chat-controller";

export function useChatFabModeWhileMobile(mode: ChatFabMode) {
    const isMobile = useIsMobileViewport();
    useSyncExternalStore(
        () => (isMobile ? requestChatFabMode(mode) : () => {}),
        () => `${isMobile}:${mode}`,
        () => `${isMobile}:${mode}`,
    );
}

export function useChatFabContentDock(enabled: boolean) {
    useSyncExternalStore(
        () => (enabled ? requestChatFabDock("content") : () => {}),
        () => enabled,
        () => enabled,
    );
}
